<script>
  import ModalButtons from 'root/services/modals/ModalButtons.YesNo.svelte';
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import {rfpManagerRepository, httpErrorHandler, notificationUtils, mainAPI} from 'root/angular-injector-provider';
  import orderBy from 'lodash/orderBy';
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import UserDetailsHeader from 'vRoot/account-profile/modules/manage-users/UserDetailsHeader.svelte';

  export let cancel, hide, userAccount;

  const LOADING = 'LOADING';

  let
    companies = LOADING,
    selected = [],
    userType,
    working = true;


  (function initialize(){
    userType = userAccount.type;

    rfpManagerRepository().listAllCompanies()
      .then(response => {
        const accounts = companies = response.data
          .filter(a => a.type === 'COMPANY')
          .map(c => {
            c.managedByUser = userAccount.managedAccounts.includes(c.id);
            if(c.managedByUser){
              selected.push(c.id);
            }

            return c;
          });
        companies = orderBy(accounts, ['managedByUser', 'name'], ['desc', 'asc']);
        if(companies.length){ working = false; }
      })
      .catch(error => httpErrorHandler().handle(error));
  })();

  function toggleSelected(companyId){
    selected = selected.includes(companyId)? selected.filter(s => s !== companyId): [...selected, companyId];
  }

  function save(){
    working = true;
    const managedAccountsChanged = selected.length !== userAccount.managedAccounts.length ||
      [...new Set([...selected, ...userAccount.managedAccounts])].length !== userAccount.managedAccounts.length;
    const userTypeChanged = userType !== userAccount.type;
    if(managedAccountsChanged || userTypeChanged){
      const updateFunction = userAccount.status === 'INVITED'?
        mainAPI().manageAccount.updateInviteeAssignmentsAndType :
        mainAPI().manageAccount.updateUserAssignmentsAndType;

      const type = userType === 'Administrator' ? 'ADMIN' : 'USER';
      notificationUtils().onSave(() => updateFunction(userAccount.accountId, userAccount._id, type, selected))
        .then(() => hide(managedAccountsChanged? {
          added: selected.filter(s => !userAccount.managedAccounts.includes(s)),
          removed: userAccount.managedAccounts.filter(a => !selected.includes(a)),
        }: undefined))
    } else {
      hide();
    }
  }

</script>


<ClosableModal width="650px" close="{cancel}">
  <div slot="heading">
    <UserDetailsHeader
      isEditable="{true}"
      {userAccount}
      {userType}
      onChange="{type => {userType = type}}"
    />
  </div>

  {#if companies === LOADING}
    <div class="Notification">
      <SpinnerWithText />
    </div>
  {:else if !companies.length}
    <div class="Notification">
      There are no companies to assign!
    </div>
  {:else}
    <div class="Body">
      <div class="CompaniesHeader">
        <span>
          {#if selected.length}
            User is assigned to { selected.length } Compan{ selected.length > 1? 'ies': 'y' }
          {:else}
            User is not assigned to any company
          {/if}
        </span>
        <span>User Assigned:</span>
      </div>


      <div class="Companies">
        {#each companies as company}
          <div
            class="Company"
            class:ManagedByUser={company.managedByUser}
            data-icon-before="{selected.includes(company.id)? 'check_box': 'check_box_outline_blank'}"
            on:click={() => toggleSelected(company.id)}
          >
            <div class="CompanyName">{company.name}</div>

            <div class="CompanyAgent">
              {#if company.primaryAgent && company.primaryAgent.userDetails}
                <span>{company.primaryAgent.userDetails.fullName}</span>
              {:else}
                <span class="NotAssigned" data-icon-after="warning">Not Assigned</span>
              {/if}
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/if}

  <ModalButtons
    disabled="{working}"
    noAction="{cancel}"
    noLabel="Cancel"
    yesLabel="Apply Changes"
    yesIcon="account_circle"
    yesAction="{save}"
  />
</ClosableModal>

<style lang="stylus">

  .Notification {
    padding: 20px;
    font-size: 14px;
    font-weight: bold;
    color #546E7A;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Body {
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 0 15px;
    color #546E7A;
    font-size 13px;
  }

  .CompaniesHeader {
    display flex;
    justify-content space-between;
    align-items center;
    padding 5px;
  }

  .Companies {
    overflow: auto;
    max-height: 50vh;
    border: 1px solid #B0BEC5;
    border-radius: 5px;
  }

  .Company {
    padding: 10px;
    height: 42px;
    border-bottom: 1px solid #eceff1;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }

  :nth-last-child(1 of .ManagedByUser) {
    border-bottom 3px solid #CFD8DC;
  }

  .CompanyName {
    margin-left: 5px;
    white-space: nowrap;
  }

  .CompanyAgent {
    flex: 1 1 100%;
    white-space: nowrap;
    text-align: right;
  }

  .NotAssigned {
    color: #f25b26;

    &:after {
      font-size: 16px;
      margin-left: 3px;
    }
  }

</style>
